<template lang="pug">
tbody.thead
  tr
    template(v-if="walker.sub_show")
      th
        | {{ walker.sub_label }}
    template(v-if="walker.third_show")
      th
        | {{ walker.third_label }}
    template(v-else)
      th
    th(v-if="tableShowDescription")
      | Description
    th(v-if="tableShowAmount")
      | Amount
    th(v-if="tableShowCategory")
      | Category
    th(v-if="tableShowNotes")
      | Notes
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ExpensesReportTableHeader',
  computed: {
    ...mapGetters(['walker', 'tableShowNotes', 'tableShowDescription', 'tableShowCategory', 'tableShowAmount']),
  },
};
</script>
